import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-industry-app',
  templateUrl: './industry-app.component.html',
  styleUrls: ['./industry-app.component.css']
})
export class IndustryAppComponent implements OnInit {
  leftMenu1 = true;
  leftMenu2 = false;
  leftMenu3 = false;
  leftMenu4 = false;
  leftMenu5 = false;
  leftMenu6 = false;
  leftMenu7 = false;
  leftMenu8 = false;
  leftMenu9 = false;
  leftMenu10 = false;
  leftMenu11 = false;

  constructor(private service: LoginService, private router: Router) { }

  ngOnInit() {

  }

  use(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "生态环境")
        this.router.navigate(["/industryApp/sthj"])
        this.leftMenu1 = true
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 2:
        localStorage.setItem('type', "应急管理")
        this.router.navigate(["/industryApp/yjgl"])
        this.leftMenu1 = false
        this.leftMenu2 = true
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 3:
        localStorage.setItem('type', "自然资源")
        this.router.navigate(["/industryApp/zrzy"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = true
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 4:
        localStorage.setItem('type', "灾害防治")
        this.router.navigate(["/industryApp/zhfz"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = true
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 5:
        localStorage.setItem('type', "林业草原")
        this.router.navigate(["/industryApp/lycy"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = true
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 6:
        localStorage.setItem('type', "城乡住建")
        this.router.navigate(["/industryApp/cxzj"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = true
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 7:
        localStorage.setItem('type', "文物保护")
        this.router.navigate(["/industryApp/wwbh"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = true
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 8:
        localStorage.setItem('type', "交通运输")
        this.router.navigate(["/industryApp/jtys"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = true
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 9:
        localStorage.setItem('type', "农业农村")
        this.router.navigate(["/industryApp/nync"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = true
        this.leftMenu10 = false
        this.leftMenu11 = false
        break
      case 10:
        localStorage.setItem('type', "公益诉讼")
        this.router.navigate(["/industryApp/gyss"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = true
        this.leftMenu11 = false
        break
      case 11:
        localStorage.setItem('type', "红色甘肃")
        this.router.navigate(["/industryApp/hsgs"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        this.leftMenu8 = false
        this.leftMenu9 = false
        this.leftMenu10 = false
        this.leftMenu11 = true
        break
    }

  }

}
